import RetryAction from '@/classes/SubmissionActions/RetryAction'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import { SubmissionStatusMapper } from '@/classes/SubmissionStatuses/SubmissionStatusMapper'
import type { SubmissionAction } from '@/classes/SubmissionStatuses/types'
import type { SubmissionChannel } from '@/services/types'
import type { UploadItem } from '@/types'

export class EmailStatusMapper extends SubmissionStatusMapper {
	constructor(
		private outgoingSubmissionStatuses: {
			submissionChannel: SubmissionChannel
			status: UploadItem<any>['uploadStatus']
		}[]
	) {
		super()
	}

	getVendorName() {
		return 'Receipt'
	}

	getThemeVariant(): StatusThemeVariant {
		if (this.hasOutgoingError()) {
			return StatusThemeVariant.ERROR
		}

		if (this.getEmailStatus()?.status === 'complete') {
			return StatusThemeVariant.SUCCESS
		}

		return StatusThemeVariant.INACTIVE
	}

	getStatusText() {
		const emailStatus = this.getEmailStatus()

		if (!emailStatus) {
			return 'None Sent'
		}

		if (this.hasOutgoingError()) {
			return 'Send Failed'
		}

		if (emailStatus.status === 'complete') {
			return 'Emailed'
		}

		return 'None Sent'
	}

	getToolTipText() {
		if (this.hasOutgoingError()) {
			return {
				title: 'Receipt Email Not Successful',
				body: 'There was an error when emailing this receipt. Click Retry to resend. Have questions? Contact salesstudio@precoa.com.',
			}
		}

		if (this.getEmailStatus()?.status === 'complete') {
			return {
				title: 'Receipt Email Successful',
				body: 'This receipt was successfully emailed to the family.',
			}
		}

		return {
			title: 'None Sent',
			body: 'There is no record of this email being sent. If you believe this is an error, please contact salesstudio@precoa.com.',
		}
	}

	getActions(): SubmissionAction[] {
		return this.hasOutgoingError() ? [new RetryAction(['Email'])] : []
	}

	getUpdatedAt() {
		return ''
	}

	private getEmailStatus() {
		return this.outgoingSubmissionStatuses.find(
			({ submissionChannel }) => submissionChannel === 'Email'
		)
	}

	private hasOutgoingError() {
		const emailStatus = this.getEmailStatus()

		return (
			!!emailStatus &&
			['sending', 'failed', 'waitingForNetwork'].includes(emailStatus.status)
		)
	}
}
